import {core} from './core.js';
import {drawTriangles, drawArray} from './drawArray.js';
import {coords} from './coords.js';

export const definitions = {
    ...core,
    drawArray,
    drawTriangles
};
